import React from "react";
import _ from "lodash";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useDispatch, useSelector } from "react-redux";
import { IBMCWithRatingData } from "src/redux/interfaces/IBMCWithRating";
import {
  clearBMCWithRatingPopupData,
  setIsBMCWithRatingDetailsPopupOpen,
  setIsSendRequestToBMCPopupOpen,
  setSendRequestToBMCPopupData,
} from "src/redux/slices/bmcWithRatingSlice";
import { useTranslation } from "react-i18next";

import {
  convertDateIFNotMin,
  getTextValueById,
  isArabic,
} from "src/utils/helpers";
import PaymentStatus from "src/components/PaymentStatus/PaymentStatus";
import VerticalDivider from "src/components/VerticalDivider/VerticalDivider";
import { ReactComponent as ExportNotesIcon } from "../../../../assets/icons/export_notes.svg";
import SendRequestToBMCPopup from "./SendRequestToBMCPopup";

const BMCWithRatingDetailsPopup = () => {
  const dispatch = useDispatch();
  const { id } = useSelector(
    (state: any) => state.bmcWithRating.bmcWithRatingDetailsPopupData
  );
  const allServiceTerritories = useSelector(
    (state: any) => state.lookup.allServiceTerritories
  );
  function selectBMCWithRating(): (state: any) => any {
    return (state: any) =>
      state.bmcWithRating.bmcWithRatingData?.find(
        (bmcWithRating: IBMCWithRatingData) => bmcWithRating.id === id
      );
  }
  const selectedBMCWithRating = useSelector(selectBMCWithRating());
  const isBMCWithRatingDetailsPopupOpen = useSelector(
    (state: any) => state.bmcWithRating.isBMCWithRatingDetailsPopupOpen
  );

  const { t } = useTranslation([
    "common",
    "registration",
    "bmcWithRating",
    "invoiceDetails",
  ]);
  const emirateOptions = useSelector(
    (state: any) => state.lookup.emiratesOptions
  );

  function closePopup(): void {
    dispatch(setIsBMCWithRatingDetailsPopupOpen(false));
    dispatch(clearBMCWithRatingPopupData());
  }
  const handleSendRequestToBMC = (): void => {
    // dispatch(setBMCWithRatingPopupData({ field: "bmcId", value: id }));
    dispatch(setSendRequestToBMCPopupData({ field: "bmcId", value: id }));
    dispatch(setIsSendRequestToBMCPopupOpen(true));
  };

  function getEmirate(id: any) {
    return getTextValueById(id, emirateOptions, "emirateId");
  }
  const getBMCTerritories = () => {
    const territories = selectedBMCWithRating?.territories;
    if (_.isEmpty(territories)) return "";
    const selectedTerritories = _.map(territories, (territory: any) => {
      return getTextValueById(
        territory.territoryId,
        allServiceTerritories,
        "territoryId"
      );
    });
    const separator = isArabic() ? "، " : ", ";
    return selectedTerritories.filter(Boolean).join(separator);
  };
  return (
    <>
      <Dialog
        visible={isBMCWithRatingDetailsPopupOpen}
        onHide={closePopup}
        header={t("bmcWithRating")}
        headerClassName="popup-header"
        className="maintenance-requests-details-popup"
      >
        <div className="pt-3">
          <div className="d-flex justify-content-between flex-wrap  gap-2 align-items-start mb-2 popup-top-section">
            <div className="section-body__item ">
              <h4 className="font-weight-size-bmc-title">{t("companyName")}</h4>
              <span className="font-weight-size-bmc-data">
                {selectedBMCWithRating?.name}
              </span>
            </div>
            <div className="section-body__item">
              <h4 className="font-weight-size-bmc-title">
                {t("companyRating")}
              </h4>
              <span className="font-weight-size-bmc-data">
                {selectedBMCWithRating?.rating}%
              </span>
            </div>
            <div className="section-body__item  ">
              <h4 className=" font-weight-size-bmc-title ">
                {t("paymentStatus")}
              </h4>

              <PaymentStatus status={selectedBMCWithRating?.paymentStatus} />
            </div>
            <Button
              label={t("sendRequestToBMC")}
              className="edit-btn"
              icon={<ExportNotesIcon />}
              onClick={handleSendRequestToBMC}
            />
          </div>

          <section className="bmc-with-rating-popup-internal-header  ">
            <div className="section-body justify-content-between  ">
              <div className="section-body__item w-100">
                <h4 className="font-weight-700 white-text">
                  {t("tradeLicenseNumber")}
                </h4>
                <span className="  white-text">
                  {selectedBMCWithRating?.tradeLicenseNumber}
                </span>
              </div>
              <VerticalDivider />
              <div className="section-body__item w-100">
                <h4 className="font-weight-700 white-text">
                  {t("tradeLicenseExpirationDate")}
                </h4>
                <span className="  white-text">
                  {convertDateIFNotMin(
                    selectedBMCWithRating?.tradeLicenseExpiry
                  )}
                </span>
              </div>
              <VerticalDivider />
              <div className="section-body__item w-100">
                <h4 className="font-weight-700 white-text">
                  {t("civilDefenseLicenseNumber")}
                </h4>

                <span className="white-text">
                  {selectedBMCWithRating?.civilDefenseLicense}
                </span>
              </div>
              <VerticalDivider />
              <div className="section-body__item w-100">
                <h4 className="font-weight-700 white-text">
                  {t("civilDefenseLicenseExpirationDate")}
                </h4>

                <span className="  white-text">
                  {convertDateIFNotMin(
                    selectedBMCWithRating?.civilDefenseLicenseExpiry
                  )}
                </span>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-weight-700 ">
              {t("invoiceDetails.propertyDetails")}
            </h2>
            <div className="section-body">
              <div className="section-body__item w-32">
                <h4 className="font-weight-700">{t("latitude")}</h4>
                <span>{selectedBMCWithRating?.lat}</span>
              </div>
              <VerticalDivider />
              <div className="section-body__item w-32">
                <h4 className="font-weight-700">{t("longitude")}</h4>
                <span>{selectedBMCWithRating?.lon}</span>
              </div>
              <VerticalDivider />
              <div className="section-body__item w-32">
                <h4 className="font-weight-700">{t("serviceTerritory")}</h4>
                <span>{getBMCTerritories()}</span>
              </div>
            </div>
            <div className="section-body">
              <div className="section-body__item  w-32">
                <h4 className="font-weight-700">{t("emirate")}</h4>
                <span>
                  {getEmirate(selectedBMCWithRating?.emirate)}{" "}
                  {selectedBMCWithRating?.numberOfBuildings}
                </span>
              </div>
              <VerticalDivider />
              <div className="section-body__item  w-32">
                <h4 className="font-weight-700">{t("numberOfBuildings")}</h4>
                <span> {selectedBMCWithRating?.numberOfBuildings}</span>
              </div>
            </div>
          </section>
          <section>
            <h2 className="font-weight-700">{t("contactInformation")}</h2>
            <div className="section-body">
              <div className="section-body__item  w-32">
                <h4 className="font-weight-700">{t("contactPersonName")}</h4>
                <span>{selectedBMCWithRating?.contactPersonName}</span>
              </div>
              <VerticalDivider />
              <div className="section-body__item w-32">
                <h4 className="font-weight-700">{t("designation")}</h4>
                <span>{selectedBMCWithRating?.designation}</span>
              </div>
              <VerticalDivider />
              <div className="section-body__item  w-32">
                <h4 className="font-weight-700">{t("phoneNumber")}</h4>
                <span>{selectedBMCWithRating?.phoneNumber}</span>
              </div>
            </div>
          </section>
          <section>
            <h2 className="font-weight-700">{t("companyInformation")}</h2>
            <div className="section-body">
              <div className="section-body__item  w-32">
                <h4 className="font-weight-700">{t("noOfTechnician")}</h4>
                <span>{selectedBMCWithRating?.numberOfTechnician}</span>
              </div>
              <VerticalDivider />

              <div className="section-body__item  w-32">
                <h4 className="font-weight-700">
                  {t("noOfElectricalTechnician")}
                </h4>
                <span>
                  {selectedBMCWithRating?.numberofElectricalTechnician}
                </span>
              </div>
              <VerticalDivider />
              <div className="section-body__item">
                <h4 className="font-weight-700">
                  {t("noOfMechanicalTechnician")}
                </h4>
                <span>
                  {selectedBMCWithRating?.numberOfMechanicalTechnician}
                </span>
              </div>
            </div>
            <div className="section-body">
              <div className="section-body__item  w-32">
                <h4 className="font-weight-700">
                  {t("noOfCertifiedEngineers")}
                </h4>
                <span>{selectedBMCWithRating?.numberOfCertifiedEngineers}</span>
              </div>
              <VerticalDivider />
              <div className="section-body__item  w-32">
                <h4 className="font-weight-700">
                  {t("noOfElectricalEngineer")}
                </h4>
                <span>{selectedBMCWithRating?.numberOfElectricalEngineer}</span>
              </div>
              <VerticalDivider />

              <div className="section-body__item">
                <h4 className="font-weight-700">
                  {t("noOfMechanicalEngineer")}
                </h4>
                <span>{selectedBMCWithRating?.numberOfMechanicEngineer}</span>
              </div>
            </div>
          </section>
        </div>
      </Dialog>
      <SendRequestToBMCPopup />
    </>
  );
};

export default BMCWithRatingDetailsPopup;
